// src/graphql/queries/deepCrawlQueries.js

export const getDeepCrawlSiteConfigs = () => `query GetDeepCrawlSiteConfigs($active: Boolean, $expiredOnly: Boolean, $limit: Int, $offset: Int) {
    deepCrawlSiteConfigs(active: $active, expiredOnly: $expiredOnly, limit: $limit, offset: $offset) {
        items {
            id
            domain
            baseUrl
            structureType
            confidence
            analysis
            extraction
            llmParams
            analyzedAt
            expiresAt
            successCount
            failureCount
            successRate
            active
            createdAt
            updatedAt
        }
        totalCount
        hasMore
    }
}`;

export const getDeepCrawlSiteConfig = () => `query GetDeepCrawlSiteConfig($domain: String!) {
    deepCrawlSiteConfig(domain: $domain) {
        id
        domain
        baseUrl
        structureType
        confidence
        analysis
        extraction
        llmParams
        analyzedAt
        expiresAt
        successCount
        failureCount
        successRate
        active
        createdAt
        updatedAt
    }
}`;

export const getDeepCrawlTelemetry = () => `query GetDeepCrawlTelemetry($configId: String!, $successOnly: Boolean, $failureOnly: Boolean, $limit: Int, $offset: Int) {
    deepCrawlTelemetry(configId: $configId, successOnly: $successOnly, failureOnly: $failureOnly, limit: $limit, offset: $offset) {
        items {
            id
            siteConfigId
            tenderId
            sourceUrl
            success
            documentsFound
            errorMessage
            duration
            details
            createdAt
        }
        totalCount
        hasMore
    }
}`;

export const getDeepCrawlStats = () => `query GetDeepCrawlStats {
    deepCrawlStats {
        totalSiteConfigs
        activeSiteConfigs
        expiredSiteConfigs
        totalTelemetryEntries
        recentSuccessRate
        recentFailureCount
        topDomains {
            domain
            tenderCount
            successCount
            failureCount
            successRate
            lastCrawled
        }
        topDomainsByTenderCount {
            domain
            tenderCount
            successCount
            failureCount
            successRate
            lastCrawled
        }
    }
}`;
